import styled, { css } from 'styled-components';
import { TextareaAutosize, } from "@material-ui/core";

export const Label = styled.span`
  font-size: 10 px;
  color: #0000008a;

  ${props => props.errored && css`
    color: #fe0000;
  `}

  ${props => props.disabled && css`
    color: #00000061;
  `}
`;

export const ITextareaAutosize = styled(TextareaAutosize)`
  background: #fff;
  border: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.42);
  font-size: 16px;

  ${props => props.errored && css`
    border-color: #fe0000;
  `}
  
  ${props => props.disabled && css`
    color: #00000061;
    border-bottom: 1px dashed rgba(0, 0, 0, 0.42);
  `}

  :focus-visible {
    outline: -webkit-focus-ring-color auto 0px;
  }
`;
